import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';

export default function ServicesSection() {
  const { t } = useTranslation('common');

  return (
    <section id="services" className="py-24 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16">
          <p className="text-sm text-gray-500 mb-2 font-light tracking-wider">
            {t('services.title')}
          </p>
          {t('services.heading1') && (
            <h2 className="text-5xl font-bold text-gray-900 mb-2">
              {t('services.heading1')}
            </h2>
          )}
          <h2 className="text-6xl font-bold text-gray-900 italic">
            {t('services.heading2')}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            className="bg-rose-50 rounded-3xl overflow-hidden hover:shadow-xl transition-shadow"
          >
            <div className="w-full h-80">
              <img
                src="https://public.readdy.ai/ai/img_res/d23d2d17867b2bb983a6cdc6e5080137.jpg"
                alt="Business Consulting"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 bg-white">
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {t('services.consulting.title')}
              </h3>
              <p className="text-sm text-gray-600">
                {t('services.consulting.desc')}
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.1 }}
            className="bg-emerald-50 rounded-3xl overflow-hidden hover:shadow-xl transition-shadow"
          >
            <div className="w-full h-80">
              <img
                src="https://static.readdy.ai/image/24aeac95850e55fcda9f6af40f64c6a6/e8341018be7ab8f9c93c02e7cb8a9087.jpeg"
                alt="Overseas Expansion"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 bg-white">
              <div className="inline-block px-3 py-1 bg-teal-600 text-white text-xs rounded-full mb-3">
                {t('services.expansion.badge')}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {t('services.expansion.title')}
              </h3>
              <p className="text-sm text-gray-600">
                {t('services.expansion.desc')}
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.2 }}
            className="bg-gray-50 rounded-3xl overflow-hidden hover:shadow-xl transition-shadow"
          >
            <div className="w-full h-80">
              <img
                src="https://readdy.ai/api/search-image?query=stunning%20tropical%20beach%20paradise%20in%20Malaysia%20with%20crystal%20clear%20turquoise%20water%20white%20sand%20palm%20trees%20and%20beautiful%20coastal%20scenery%20featuring%20sunny%20weather%20vibrant%20colors%20and%20pristine%20natural%20beauty%20perfect%20vacation%20destination&width=400&height=500&seq=travel-001&orientation=portrait"
                alt="Travel Guide"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 bg-white">
              <div className="inline-block px-3 py-1 bg-amber-600 text-white text-xs rounded-full mb-3">
                {t('services.travel.badge')}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {t('services.travel.title')}
              </h3>
              <p className="text-sm text-gray-600">
                {t('services.travel.desc')}
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.3 }}
            className="bg-amber-50 rounded-3xl overflow-hidden hover:shadow-xl transition-shadow"
          >
            <div className="w-full h-80">
              <img
                src="https://static.readdy.ai/image/24aeac95850e55fcda9f6af40f64c6a6/e8684a738dc40b7c898ab926959bd28f.jpeg"
                alt="School Support"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="p-6 bg-white">
              <div className="inline-block px-3 py-1 bg-blue-600 text-white text-xs rounded-full mb-3">
                {t('services.school.badge')}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {t('services.school.title')}
              </h3>
              <p className="text-sm text-gray-600">
                {t('services.school.desc')}
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
